import React, { Component } from "react";
import { connect } from "react-redux";
import { Page, Navbar, Toolbar, Button } from "framework7-react";
import arrayMutators from "final-form-arrays";
import _ from "lodash";

import Form from "modules/4_final_form/PersistedForm";
import HasRole from "modules/5_view_helpers/HasRole";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import { getMWJobs } from "modules/moneyworks/jobs/actions";
import { createStoreRequest } from "../actions";
import StoreRequestForm from "./form";

function mapStateToProps(state) {
  return {
    mw_jobs: state.mw_jobs,
  };
}

class NewStoreRequest extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    this.createRole = HasRole(
      {
        resource_type: "Store::Request",
        name: ["create", "moderator"],
      },
      true,
    );

    this.returnUrl = "/store/requests";
  }

  componentDidMount() {
    if (_.isEmpty(this.props.mw_jobs)) {
      this.props.getMWJobs({ filterNines: true });
    }
  }

  submitForm(values) {
    const {
      f7router: { app },
    } = this.props;
    this.preloader = app.preloader;
    this.preloader.show();
    this.props
      .createStoreRequest(values)
      .then(this.successfullySubmitted)
      .catch(() => {
        this.preloader.hide();
        app.toast
          .create({
            text: "Failed to create store request",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
      });
  }

  successfullySubmitted() {
    const {
      f7router,
      f7router: { app },
    } = this.props;

    this.preloader.hide();
    app.toast
      .create({
        icon: '<i class="material-icons">check</i>',
        text: "Created Store Request!",
        position: "center",
        closeTimeout: 2000,
        on: {
          opened: () => {
            f7router.navigate(this.returnUrl);
          },
        },
      })
      .open();
  }

  render() {
    const { mw_jobs } = this.props;

    if (!this.createRole) {
      return <NotAuthorized />;
    }

    return (
      <Page>
        <Navbar title="New Store Request" backLink />

        <Toolbar bottom>
          <Button
            fill
            size="sm"
            color="green"
            className="margin-left margin-right"
            style={{ flex: 1 }}
            onClick={() => this.handleSubmit?.()}
          >
            Submit Request
          </Button>
        </Toolbar>

        <Form
          onSubmit={this.submitForm}
          mutators={{ ...arrayMutators }}
          initialValues={{
            tool_account: false,
            line_items_attributes: [{ description: "", quantity: 1 }],
          }}
          render={(formProps) => {
            // ponytail: stash submit for bottom toolbar (needs to be Page-level for F7)
            this.handleSubmit = formProps.handleSubmit;
            return <StoreRequestForm {...formProps} mw_jobs={mw_jobs} />;
          }}
        />
      </Page>
    );
  }
}

export default connect(mapStateToProps, { createStoreRequest, getMWJobs })(NewStoreRequest);
